import React from 'react';
import './Learn.css';

const learnPages = [
	{
		title: 'Locations',
		path: '/learn/locations',
		img: require('../img/learn/locations.png'),
		desc: 'Explore the different locations featured in BioEra.',
	},
	{
		title: 'Biomes',
		path: '/learn/biomes',
		img: require('../img/learn/biomes.png'),
		desc: 'Discover the distinct biomes represented in the game.',
	},
	{
		title: 'Life Kingdoms',
		path: '/learn/life_kingdoms',
		img: require('../img/learn/life_kingdoms.png'),
		desc: 'Learn about the kingdoms of life.',
	},
	{
		title: 'Geological Periods',
		path: '/learn/geological_periods',
		img: require('../img/learn/geological_periods.png'),
		desc: 'Understand the geological periods throughout Earth\'s history.',
	},
	{
		title: 'Trophic Level',
		path: '/learn/trophic_level',
		img: require('../img/learn/trophic_levels.png'),
		desc: 'Explore trophic levels and their importance in ecosystems.',
	},
	{
		title: 'Phenomena',
		path: '/learn/phenomena',
		img: require('../img/learn/phenomena.png'),
		desc: 'Fascinating natural phenomena and behaviral phenomena that occur in nature.',
	},
];

function Learn() {
	return (
		<div className="container py-4">
			<h1 className="display-4 mb-4 text-center">Learn</h1>
			<p className="lead text-center mb-5">
				Our world is a fascinating place! BioEra lets you explore it by categories.
			</p>
			<div className="row">
				{learnPages.map((page) => (
					<div
						key={page.title}
						className="col-12 col-md-6 col-lg-4 mb-4 d-flex justify-content-center"
					>
						<div className="card h-100 shadow learn-card">

							<img
								src={page.img}
								alt={page.title}
								className="card-img-top img-fluid learn-card-img"
							/>

							<div className="card-body d-flex flex-column">
								<h5 className="card-title text-center">{page.title}</h5>
								<p className="card-text text-center">{page.desc}</p>
								{/* <Link
									to={page.path}
									className="btn mt-auto learn-button"
								>
									Learn More
								</Link> */}
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
}

export default Learn;
